import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';

import { TypeKeys } from '@common/react/store/Login';

import { pushEvent } from '@app/components/TagManager';
import ContactUs from '@app/components/UI/ContactUs/ContactUs';
import CustomMenu from '@app/components/UI/Header/CustomMenu/CustomMenu';
import styles from '@app/components/UI/Header/Header.module.scss';
import { menuLoL } from '@app/components/UI/Header/MenuLoL';
import { menuMobile } from '@app/components/UI/Header/MenuMobile/MenuMobile';
import { menuAuthorizedPHJ, menuUnauthorizedPHJ } from '@app/components/UI/Header/MenuPHJ/MenuPHJ';
import LoginForm from '@app/components/UI/Login/LoginForm';
import CustomModal from '@app/components/UI/Modal/CustomModal';
import LoginModal from '@app/components/UI/Modal/LoginModal';
import logoLoL from '@app/images/extended-logo.svg';
import BarsSVG from '@app/images/icons/BarsSVG';
import CloseSVG from '@app/images/icons/CloseSVG';
import PHJLogoSVG from '@app/images/PHJLogoSVG';
import { ApplicationState } from '@app/store';

const Header: React.FC = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const login = useSelector((state: ApplicationState) => state.login, shallowEqual);
	const [isOpenNavbar, setIsOpenNavbar] = React.useState<boolean>(false);

	const [openContactForm, setOpenContactForm] = React.useState<boolean>(false);
	const [openLoginForm, setOpenLoginForm] = React.useState<boolean>(false);

	const closeNavbar = () => {
		setIsOpenNavbar(false);
	};

	const closeLoginModal = (bool: boolean) => {
		setOpenLoginForm(bool);
		dispatch({ type: TypeKeys.CLEARSTATE });
	};

	const openModal = (str: string) => {
		if (str === 'contact-form') {
			setOpenContactForm(true);
		} else if (str === 'sign-in') {
			setOpenLoginForm(true);
		}
	};

	React.useEffect(() => {
		closeNavbar();
	}, [location]);

	React.useEffect(() => {
		const html = window?.document?.querySelector('html');
		const body = window?.document?.querySelector('body');

		if (html && body) {
			isOpenNavbar ? html.style.overflowY = 'hidden' : html.style.overflowY = 'visible';
			isOpenNavbar ? body.style.overflowY = 'hidden' : body.style.overflowY = 'visible';
		}
	}, [isOpenNavbar]);

	return (
		<>
			<header className={styles.siteHeader}>
				<nav className={styles.navbar}>
					<div className={styles.navbarWrapper}>
						<div className={styles.lol}>
							<a
								className={styles.lol__logo}
								href="https://www.lapoflove.com/"
								target="_blank"
								rel="noopener noreferrer"
							>
								<img src={logoLoL} alt="Lap of Love - logo" />
							</a>
							<div className={styles.lol__nav}>
								<CustomMenu items={menuLoL} closeMenu={closeNavbar} />
							</div>
							<div className={styles.lol__btns}>
								<a
									className="btn btn-purple-gray-border"
									href="https://www.lapoflove.com/online-booking"
									target="_blank"
									rel="noopener noreferrer"
									onClick={() => pushEvent('PHJ-ScheduleHeader')}
								>
									Schedule
								</a>
								<a
									className="btn btn-purple-gray"
									href="https://www.lapoflove.com/find-a-vet"
									target="_blank"
									rel="noopener noreferrer"
								>
									Find a Vet
								</a>
							</div>
						</div>

						<div className={styles.verticalLine} />

						<div className={styles.phj}>
							<div className={styles.phj__logo}>
								<NavLink to="/" onClick={closeNavbar}>
									<PHJLogoSVG />
									<span className={styles.phj__logoText}>
										<span className={styles.title}>
											Pet Hospice Journal
										</span>
										<span className={styles.subtitle}>
											Helping families track pet quality of life
										</span>
									</span>
								</NavLink>
							</div>
							<div className={styles.phj__nav}>
								<CustomMenu
									items={login.user ? menuAuthorizedPHJ : menuUnauthorizedPHJ}
									closeMenu={closeNavbar}
									onChangeVisibleModal={openModal}
								/>
							</div>
						</div>

						<div
							className={styles.navbarWrapper__icon}
							onClick={() => setIsOpenNavbar(!isOpenNavbar)}
						>
							{!isOpenNavbar ? <BarsSVG /> : <CloseSVG />}
						</div>

						<div className={`${styles.navbarWrapper__navBar} ${isOpenNavbar ? styles.open : styles.noOpen}`}>
							<div className={styles.navbarWrapper__navBar__container}>
								<CustomMenu
									items={menuMobile(Boolean(login.user))}
									closeMenu={closeNavbar}
									onChangeVisibleModal={openModal}
								/>
							</div>
						</div>
					</div>
				</nav>
			</header>

			{openLoginForm && (
				<LoginModal modalVisible={openLoginForm} setModalVisible={closeLoginModal}>
					<LoginForm onChangeModalVisible={closeLoginModal} />
				</LoginModal>
			)}

			{openContactForm && (
				<CustomModal modalVisible={openContactForm} setModalVisible={setOpenContactForm}>
					<ContactUs onChangeVisibleModal={setOpenContactForm} />
				</CustomModal>
			)}
		</>
	);
};

export default Header;
